namespace $.$$ {

	export class $hyoo_intern_catalog_managers extends $.$hyoo_intern_catalog_managers {

	}

}
